import { twMerge } from 'tailwind-merge';
import { logEvent } from '@/utils/analytics';
import Link, { type LinkProps } from 'next/link';
import Events from '@/utils/amplitudeEvents.json';
import { getLinkType } from '@/utils/getLinkType';
import { isBusinessRoute } from '@/utils/business-route';

interface TextLinkProps extends LinkProps {
  logEventProperties?: Record<string, unknown>;
  'data-automation'?: string;
  children?: React.ReactNode;
  'aria-label'?: string;
  className?: string;
  scroll?: boolean;
  target?: string;
  title?: string;
  rel?: string;
}

export const FakeLink = ({ className = '', children, ...rest }: React.HTMLAttributes<HTMLSpanElement>) => (
  <span {...rest} className={twMerge('text-base-content underline cursor-pointer hover:opacity-80', className)}>
    {children}
  </span>
);

export const TextLink = ({
  logEventProperties = {},
  'aria-label': ariaLabel,
  prefetch = null,
  scroll = true,
  className,
  children,
  replace,
  target,
  title,
  href,
  rel,
  ...rest
}: TextLinkProps) => {
  if (!href) {
    return (
      <FakeLink {...rest} className={className}>
        {children}
      </FakeLink>
    );
  }

  return (
    <Link
      onClick={(event) => {
        if (rest.onClick) {
          rest.onClick(event);
        }

        logEvent(Events.LINK_CLICK, {
          link_type: getLinkType(href?.toString() ?? ''),
          currentPage: window.location.href,
          text: children?.toString(),
          type: 'text-link',
          target,
          href,
          ...(isBusinessRoute(window.location.pathname) && { user_type: 'b2b' }),
          ...logEventProperties,
        });
      }}
      className={twMerge('text-base-content underline cursor-pointer hover:opacity-80', className)}
      data-automation={rest?.['data-automation']}
      aria-label={ariaLabel}
      prefetch={prefetch}
      replace={replace}
      target={target}
      scroll={scroll}
      title={title}
      href={href}
      rel={rel}
    >
      {children}
    </Link>
  );
};
